import script from "./MedalProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MedalProgressBar.vue?vue&type=script&setup=true&lang=ts"

import "./MedalProgressBar.vue?vue&type=style&index=0&id=d5c05c00&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5c05c00"]])

export default __exports__